import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import type { PropsWithChildren, ReactNode } from 'react';

const StyledContainer = styled.div(
  ({ theme }) => `
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    padding: 0 ${theme.size.static300};

    @media (min-width: ${Breakpoints.b960}px) {
        padding: 0 ${theme.size.static530};
    }
`
);

interface PageProps {
  children?: React.ReactNode
}

export default ({ children }: PageProps) => (
  <StyledContainer>{children}</StyledContainer>
);
